import React from "react";
import Customform from "../../ui/custom-form";
import CustomButton from "../../ui/custom-button";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CustomInput from "../../ui/custom-input";
import { PulseLoader } from "react-spinners";

function Login({ handleLoginSubmit, email, setEmail, loading }) {
  return (
    <>
      <Customform onSubmit={handleLoginSubmit} className="mt-4">
        <div className="withIcon mb-4">
          <label htmlFor="email">Email</label>
          <div className="position-relative">
            <span className="icon"><MailOutlineIcon /></span>
            <CustomInput className="form-control" name="email" type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
        </div>

        <button className="codepenButton submitBtn w-100 mb-4" width={"100%"} size="large" type="submit">
          {loading ? (
            <span className="loader"><PulseLoader color="#fff" /></span>
          ) : (
            <span>Sign in</span>
          )}
        </button>

        {/* {loading ? (
          <button
            type="submit"
            className="codepenButton submitBtn w-100 mb-4"
            width={"100%"}
            size="large"
          >
            <span className="loader"><PulseLoader color="#fff" /></span>
          </button>
        ) : (
          <button
            type="submit"
            className="codepenButton submitBtn w-100 mb-4"
            width={"100%"}
            size="large"
            //   loading={loading}
          >
            <span>Sign in</span>
          </button>
        )} */}
      </Customform>
    </>
  );
}

export default Login;
